import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "h-[100dvh] w-screen flex flex-col items-center bg-login text-white pt-[15vh]"
};
const _hoisted_2 = {
  class: "flex flex-row items-center gap-2 text-[clamp(1.5rem,1.5rem+0.75vw,3rem)]"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-solid fa-file-circle-question"
  }), _createElementVNode("div", null, _toDisplayString(_ctx.$t('not found')), 1)]), _createElementVNode("div", {
    class: "link flex items-center pointer mt-6 underline text-[clamp(1rem,1rem+0.5vw,2rem)]",
    onClick: _cache[0] || (_cache[0] = $event => $options.backClick())
  }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Go Back')), 1)])]);
}